"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_1 = require("./base");

var Atom;

(function (Atom) {
  /**
   * Create an atom with given initial value.
   *
   * @export
   * @template T type of atom values
   * @param initialValue initial value for this atom
   * @returns fresh atom
   */
  function create(initialValue) {
    return new base_1.JsonAtom(initialValue);
  }

  Atom.create = create; // tslint:enable no-unused-vars

  function log(atom, logger) {
    var logState = function logState(msg, color, x) {
      return console.log('%c' + msg, "color: " + color + "; font-weight: bold", x);
    };

    var prevState = atom.get();
    atom.subscribe(function (newState) {
      if (typeof logger === 'function') {
        logger(prevState, newState);
      } else {
        console.group("UPDATE " + (logger ? "TYPE: " + logger + " " : '') + "@ " + new Date().toTimeString());
        logState('prev state', '#9E9E9E', prevState);
        logState('next state', '#4CAF50', newState);
        console.groupEnd();
      }

      prevState = newState;
    });
    return atom;
  }

  Atom.log = log; // tslint:enable no-unused-vars

  function combine() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return new base_1.CombinedAtomViewImpl(args.slice(undefined, -1), function (xs) {
      return args[args.length - 1].apply(args, xs);
    });
  }

  Atom.combine = combine;
})(Atom = exports.Atom || (exports.Atom = {}));